import axios from './axiosConfig';
import common from './common';
const api = {

    // 客户管理
    getustList: (limit, page, cn, ip) => axios.post('/cust/findByParamsWithPage', { limit: limit, page: page, custName: cn, legalPerson: ip }),
    getustDetail: (custID) => axios.post('/cust/findDetailByCustID', { custID: custID }),
    getustImportantNews: (limit, page, custID) => axios.post('/cust/findImportantNewsByParamWithPage', { limit: limit, page: page, custID: custID }),
    getImportantNewsByID: (newsID) => axios.post('/cust/getImportantNewsByID', { newsID: newsID }),
    // 新闻审核
    getUnapprovedNews: (limit, page, cn, sc, uf, ca, vd, ps) => axios.post('/pageNews/findPageNewsWithPage',
        { 'params[limit]': limit, 'params[pageNum]': page, 'params[custName]': cn, 'params[source]': sc, 'params[urlFrom]': uf, 'params[category]': ca, 'params[verifyDays]': vd, 'params[pageState]': ps }),
    nextVerifyPageNews: (cn, sc, uf, ca, vd, ts, ps = 0) => axios.post('/pageNews/getNextVerifyPageNewsByPageNewsID',
        { 'params[custName]': cn, 'params[source]': sc, 'params[urlFrom]': uf, 'params[category]': ca, 'params[verifyDays]': vd, 'params[timeStr]': ts, 'params[pageState]': ps }),
    PreviousVerifyPageNews: (cn, sc, uf, ca, vd, ts, ps = 0) => axios.post('/pageNews/getPreviousVerifyPageNewsByPageNewsID',
        { 'params[custName]': cn, 'params[source]': sc, 'params[urlFrom]': uf, 'params[category]': ca, 'params[verifyDays]': vd, 'params[timeStr]': ts, 'params[pageState]': ps }),
    changePageNewsState: (pageNewsID, pageState) => axios.post('/pageNews/changePageNewsState', { pageNewsID: pageNewsID, pageState: pageState }),
    // 应收账款updateBy
    getCurrentUserBusiness: () => axios.get('/user/getCurrentUserBusiness'),
    getAgingCountMapByAgingTime: (agingTime) => axios.post('/agingNormal/getAgingCountMapByAgingTime', { agingTime: agingTime }), // 判断该月份是否有账款
    finCustsByBusinessAndDept: (businessID, deptID, jiatuoType) => axios.post('/cust/finCustsByBusinessAndDept', { businessID: businessID, deptID: deptID, jiatuoType: jiatuoType }),
    AgingNormalListForNormal: (limit, pageNum, at, bID, dID, cID) => axios.post('/agingNormal/findAgingNormalForPageByParams',
        { limit: limit, pageNum: pageNum, agingTime: at, businessID: bID, deptID: dID, custID: cID }),
    AgingNormalListForJiatuo: (limit, pageNum, at, bID, dID, cID) => axios.post('/agingJiatuo/findAgingNormalForPageByParams',
        { limit: limit, pageNum: pageNum, agingTime: at, businessID: bID, deptID: dID, custID: cID }),
    // 组织部相关API
    getDeptsByDeptID: (deptID, jiatuoType = null) => axios.post('/dept/getDeptsByBusinessID', { deptID: deptID, jiatuoType: jiatuoType }),
    getAllDept: () => axios.post('/dept/getAllDept'),
    getBusinessesByBusinessID: (deptID, jiatuoType = null) => axios.post('/dept/getBusinessesByBusinessID', { deptID: deptID, jiatuoType: jiatuoType }),
    // 行业动态
    findBySecondMenuID: (secondMenuID) => axios.post('/thirdMenu/findBySecondMenuID', { secondMenuID: secondMenuID }),
    addIndustryDoc: (industryDocID, companyName, title, importantFlag, description, file, ct, url, pushFlag) => axios.post('/industryDoc/addIndustryDoc',
        {
            'thirdMenu.thirdMenuID': industryDocID,
            companyName: companyName,
            title: title,
            importantFlag: importantFlag,
            description: description,
            file: file,
            createDate: ct,
            pushFlag: pushFlag,
            Url: url
        }),
    getIndustryList: (st, et, smId, title, cn, importantFlag, description) => axios.post('/industryDoc/findIndustryDocByParams', {
        'params[startTime]': st,
        'params[endTime]': et,
        'params[secondMenuID]': smId,
        'params[title]': title,
        'params[companyName]': cn,
        'params[importantFlag]': importantFlag,
        'params[description]': description
    }),
    findIndustryDocByID: (industryDocID) => axios.post('/industryDoc/findIndustryDocByID', { industryDocID: industryDocID }),
    findIndustryDocFileByID: (industryDocID) => axios.post('/industryDoc/findIndustryDocFileByID', { industryDocID: industryDocID }),

    findIndustryDocFileByIDWithBase64: (industryDocID) => axios.post('/industryDoc/findIndustryDocFileByIDWithBase64', { industryDocID: industryDocID }),
    findIndustryDocFileByIDWithBase64ImageListForLimit: (industryDocID, start, end) => axios.post('/industryDoc/findIndustryDocFileByIDWithBase64ImageListForLimit',
        { industryDocID: industryDocID, startIndex: start, endIndex: end }),
    findIndustryDocFileByIDWithBase64ImageList: (industryDocID) => axios.post('/industryDoc/findIndustryDocFileByIDWithBase64ImageList', { industryDocID: industryDocID }),
    // 添加评论
    addDocComment: (industryDocID, goodFlag, comment) => axios.post('/docComment/addDocComment', { industryDocID: industryDocID, goodFlag: goodFlag, comment: comment }),
    // 查找评论
    findByIndustryDocID: (industryDocID, limit, pageNum) => axios.post('/docComment/findByIndustryDocIDForPage', { industryDocID: industryDocID, limit: limit, pageNum: pageNum }),
    // findByIndustryDocID: (industryDocID, limit, pageNum) => axios.post('/docComment/findByIndustryDocID', { industryDocID: industryDocID, limit: limit, pageNum: pageNum }),
    // 添加浏览记录
    addDocLog: (industryDocID) => axios.post('/docLog/addDocLog', { industryDocID: industryDocID }),
    // 电子发票
    saveInvoice: (ic, invoiceNum, money, id, cc, it, deptName, username) => axios.post('/invoice/saveInvoice',
        { invoiceCode: ic, invoiceNum: invoiceNum, money: money, invoicingDate: id, checkCode: cc, invoiceType: it, deptName: deptName, username: username }),
    getInvoiceList: (invoiceNum, invoiceCode, limit, page) => axios.post('/invoice/findPageByParams', { invoiceNum: invoiceNum, invoiceCode: invoiceCode, limit: limit, page: page }),

    // 修改密码
    changePassword: (username, oldPassword, newPassword) => axios.post('/user/changePassword', { username: username, oldPassword: oldPassword, newPassword: newPassword }),
    // 推送
    weiXinPush: (industryDocID) => axios.post('/photo/weiXinPush', { industryDocID: industryDocID }),
    // 删除新闻
    deleteIndustryDoc: (industryDocID) => axios.post('/industryDoc/removeIndustryDoc', { industryDocID: industryDocID }),
    // 撤退推送
    messageWithdrawn: (industryDocID) => axios.post('/pushNews/messageWithdrawn', { industryDocID: industryDocID }),
    common
};
export default api;
